import { CheckCircle2, ShieldCheck, Sparkles } from 'lucide-react';

const steps = [
	'Configure your database and encryption keys in gallocrm.json',
	'Run the Go service and complete bootstrap admin creation',
	'Add email domains, SMTP profiles, and IMAP mailboxes',
	'Enable OAuth/OIDC providers and invite your team'
];

export function SetupPage() {
	return (
		<div className="mx-auto max-w-5xl space-y-8">
			<section className="rounded-[2rem] border border-subtle bg-gradient-to-br from-accent/20 via-accent to-accent/5 p-8 shadow-panel">
				<div className="flex items-center gap-3 text-accent">
					<Sparkles className="h-5 w-5" />
					<span className="text-sm font-semibold uppercase tracking-[0.3em]">First-run setup</span>
				</div>
				<h1 className="mt-6 text-4xl font-semibold text-primary">Prepare GalloCRM for production launch</h1>
				<p className="mt-4 max-w-3xl text-base leading-7 text-secondary">
					Your API reports that initial setup is still required. Finish bootstrap on the Go backend, then come back here to sign in and operate the workspace.
				</p>
			</section>
			<section className="grid gap-6 lg:grid-cols-[1fr_0.85fr]">
				<div className="rounded-[2rem] border border-subtle bg-surface-2/80 p-6 shadow-panel">
					<h2 className="text-xl font-semibold text-primary">Launch checklist</h2>
					<div className="mt-6 space-y-4">
						{steps.map((step, index) => (
							<div key={step} className="flex gap-4 rounded-2xl border border-subtle bg-surface-2 p-4">
								<div className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-sm font-semibold text-accent-contrast">{index + 1}</div>
								<p className="text-sm leading-6 text-secondary">{step}</p>
							</div>
						))}
					</div>
				</div>
				<div className="rounded-[2rem] border border-subtle bg-surface-2/80 p-6 shadow-panel">
					<div className="flex items-center gap-3 text-emerald-300">
						<ShieldCheck className="h-5 w-5" />
						<h2 className="text-xl font-semibold text-primary">Production posture</h2>
					</div>
					<div className="mt-6 space-y-4 text-sm leading-6 text-secondary">
						<div className="rounded-2xl border border-subtle bg-surface-2 p-4">Use strong encryption and JWT secrets before inviting users.</div>
						<div className="rounded-2xl border border-subtle bg-surface-2 p-4">Put the API behind TLS and configure your public base URL for auth and email links.</div>
						<div className="rounded-2xl border border-subtle bg-surface-2 p-4">When deployed on Cloudflare Pages, point the frontend at the API origin or front it through your preferred edge routing model.</div>
					</div>
					<div className="mt-6 flex items-center gap-3 rounded-2xl border border-emerald-400/20 bg-emerald-400/10 p-4 text-sm text-emerald-200">
						<CheckCircle2 className="h-5 w-5" />
						<span>This React app is now structured as a static SPA suitable for Cloudflare Pages.</span>
					</div>
				</div>
			</section>
		</div>
	);
}
